/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.embed.defs'

type $nsid = typeof $nsid

export { $nsid }

/** width:height represents an aspect ratio. It may be approximate, and may not correspond to absolute dimensions in any given unit. */
type AspectRatio = {
  $type?: 'app.bsky.embed.defs#aspectRatio'
  width: number
  height: number
}

export type { AspectRatio }

/** width:height represents an aspect ratio. It may be approximate, and may not correspond to absolute dimensions in any given unit. */
const aspectRatio = /*#__PURE__*/ l.typedObject<AspectRatio>(
  $nsid,
  'aspectRatio',
  /*#__PURE__*/ l.object({
    width: /*#__PURE__*/ l.integer({ minimum: 1 }),
    height: /*#__PURE__*/ l.integer({ minimum: 1 }),
  }),
)

export { aspectRatio }
